import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { defaultTheme } from './styles/defaultTheme';
import { CssBaseline, LinearProgress, ThemeProvider } from '@mui/material';
import { CompactLayout } from './modules/layout/compact/compactLayout';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './pages/scoremodel/homePage';
import { IntlProvider } from 'react-intl';
import enMessages from './lang/en.json';
import { ApplicationProvider } from './model/context/applicationContext';
import { ViewXml } from './pages/viewXml';
import { ScoreModelProvider } from './model/context/scoreModelContext';
import { Suspense } from 'react';
import { ActionModal } from './modules/actionModal';
import { SnackbarProvider } from 'notistack';
import { InputBlockVarables } from './pages/variables/inputBlockVariables';
import RulesPage from './pages/rules/rulesPage';

import { OidcProvider } from './model/context/v2/OidcContext';
import { AuthConfigurationProvider } from './model/context/v2/AuthConfigurationContext';
import React from 'react';

function DesignedApp() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <SnackbarProvider maxSnack={3}>
        <ApplicationProvider>
          <ScoreModelProvider>
            <ActionModal>
              <CssBaseline />
              <Suspense fallback={<LinearProgress />}>
                <BrowserRouter>
                  <Routes>
                    <Route path="/" element={<CompactLayout />}>
                      <Route index element={<HomePage />} />
                      <Route path="/scoremodel" element={<HomePage />} />
                      <Route path="/rules">
                        <Route index element={<RulesPage />} />
                        <Route path=":ruleid" element={<RulesPage />} />
                      </Route>
                      <Route path="/variables" element={<InputBlockVarables />} />
                      <Route path="/xml" element={<ViewXml />} />
                    </Route>
                  </Routes>
                </BrowserRouter>
              </Suspense>
            </ActionModal>
          </ScoreModelProvider>
        </ApplicationProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

function App() {
  return (
    <div className="App">
      <AuthConfigurationProvider>
        <OidcProvider>
          <React.StrictMode>
            <IntlProvider messages={enMessages} locale="en">
              <DndProvider backend={HTML5Backend}>
                <DesignedApp />
              </DndProvider>
            </IntlProvider>
          </React.StrictMode>
        </OidcProvider>
      </AuthConfigurationProvider>
    </div>
  );
}

export default App;
